<template>
  <v-container class="pa-0">
    <v-row align="center" justify="center" class="fill-height">


      <v-col cols="12" md="3" lg="3" class="pa-2">
        <p class="google-font" style="font-size: 180%">Ejemplo de perfiles públicos de la comunidad TecZoa</p>
        <p class="google-font" style="font-size: 110%">
          <!-- Del equipo de trabajo de TecZoa  -->
        </p>
        <p class="google-font" style="font-size: 110%">
          
          Los vendedores de la tienda TecZoa puede ver a la derecha, actualmente son los únicos vendedores habilitados para la web TecZoa.
          Para visualización de más perfiles públicos que forman parte de la comunidad, dar click más abajo</p>


<v-btn 
              :to="'/perfiles/'"
              class="ma-0 google-font elevation-1" 
              color="#1a73e8" 
              style="text-transform: capitalize;border-radius: 5px; color: white;"
              
              >Buscador de perfiles públicos
              </v-btn>


        <!-- <span v-for="(item, i) in whatWeDoData" :key="i">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <a :href="item.link" target="_blank" flat class="ma-0">
                <img :src="getImgUrl(item.image)" width="30" alt="" v-on="on">
              </a>
              &nbsp;&nbsp;&nbsp;
            </template>
            <span>{{ item.TechName }}</span>
          </v-tooltip>
        </span> -->

        <br><br>

        <!-- <v-btn
          :href="chapterDetails.GDGProgramWebsite"
          outlined
          target="_blank"
          rounded
          color="cyan"
          class="ml-0 google-font hidden-md-and-down"
        >
          Learn More
        </v-btn> -->
      </v-col>

      <v-col cols="12" md="9" lg="9">
        <v-row>
          <!-- <v-col cols="6" sm="6" md="3" lg="3" class="text-center pa-2">
            <v-avatar size="100" class="ma-5">
       <img src="@/assets/img/team/avatar.png" alt="Juan" />
     </v-avatar>

            <p class="google-font" style="font-size: 130%">Victor Velazquez</p>
            <p class="google-font" style="font-size: 70%">
             Desarrollador Web - INOVA Soluciones
            </p>
            <p class="google-font" style="font-size: 70%">
             Aplicación 100% paraguaya, ajustado a mis necesidades empresariales.
            </p>
          </v-col> -->

          <v-col cols="12" sm="6" md="3" lg="3" class="text-center pa-2">
            <v-avatar size="100" class="ma-5">
       <img src="@/assets/img/team/fisio.png" alt="LizMar" />
     </v-avatar>

            <p class="google-font" style="font-size: 130%">Liz Bernal</p>
            <p class="google-font" style="font-size: 70%">
             Fisioterapeuta - LIZMAR BEAUTY
            </p>
            <p class="google-font" style="font-size: 70%">
             Aplicación super fácil de utilizar para compartir todas mis redes.
            </p>

            <v-btn 
                @click="verPerfil('https://www.teczoa.com/perfil/lizmar')"
               rounded color="cyan" style="text-transform: capitalize; 
               border-radius: 5px;" outlined class="ml-0" dark>Ver Perfil
              </v-btn>
          </v-col>

          

          <v-col cols="12" sm="6" md="3" lg="3" class="text-center pa-2">
            <v-avatar size="100" class="ma-5">
       <img src="@/assets/img/team/Magno2.jpg" alt="Magno" />
     </v-avatar>

            <p class="google-font" style="font-size: 130%">Magno Portillo.</p>
            <p class="google-font" style="font-size: 70%">
             Desarrollador WEB - TECZOA
            </p>
            <p class="google-font" style="font-size: 70%">
             Aplicación enteramente gratuita y fácil de utilizar para las practicas de desarrollo.
            </p>

            <p>
             

               <v-btn 
                @click="verPerfil('https://www.teczoa.com/perfil/magzoa')"
               rounded color="cyan" style="text-transform: capitalize; 
               border-radius: 5px;" outlined class="ml-0" dark>Ver Perfil
              </v-btn>

            </p>
          </v-col>


          <!-- <v-col cols="6" sm="6" md="3" lg="3" class="text-center pa-2">
            <v-avatar size="100" class="ma-5">
       <img src="@/assets/img/team/Eva.jpg" alt="Eva" />
     </v-avatar>

            <p class="google-font" style="font-size: 130%">Eva Guadalupe</p>
            <p class="google-font" style="font-size: 70%">
              Licenciada en Análisis de Sistemas. Docente Universitaria.
            </p>
            <p class="google-font" style="font-size: 70%">
             Aplicación enteramente gratuita, con varias opciones de personalización de la interfaz.
            </p>

            <p>
             

               <v-btn 
                @click="verPerfil('https://www.teczoa.com/perfil/egpa ')"
               rounded color="cyan" style="text-transform: capitalize; 
               border-radius: 5px;" outlined class="ml-0" dark>Ver Perfil
              </v-btn>

            </p>
          </v-col> -->



<!-- 
          <v-col cols="6" sm="6" md="3" lg="3" class="text-center pa-2">
            <v-avatar size="100" class="ma-5">
       <img src="@/assets/img/team/perfilDenis.jpg" alt="Denis" />
     </v-avatar>

            <p class="google-font" style="font-size: 130%">Orlando Portillo</p>
            <p class="google-font" style="font-size: 70%">
              Zero6tienda
            </p>
            <p class="google-font" style="font-size: 70%">
             Un solo link para todo.
            </p>

            <p>
             

               <v-btn 
                @click="verPerfil('https://www.teczoa.com/perfil/Zero6tienda')"
               rounded color="cyan" style="text-transform: capitalize; 
               border-radius: 5px;" outlined class="ml-0" dark>Ver Perfil
              </v-btn>

            </p>
          </v-col> -->





        </v-row>
      </v-col>

      
      <v-col cols="12" md="12" lg="12" class="pa-2">

           <!-- OTROS COMPONENTES -->

      </v-col>



    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      chapterDetails: {
        GDGProgramWebsite: 'https://developers.google.com/programs/community/',
      },
      whatWeDoData: [
        { TechName: 'Tecnología', link: 'https://developer.android.com/', image: 'android.png' },
        { TechName: 'Salud', link: 'https://cloud.google.com/', image: 'google_cloud.png' },
        { TechName: 'Marketing', link: 'https://firebase.google.com/', image: 'firebase.png' },
        { TechName: 'Desarrollo', link: 'https://www.tensorflow.org/', image: 'tensorflow.png' },
      ],
    };
  },
  methods: {
    getImgUrl(url) {
      try {
        return require(`@/assets/img/what-we-do/${url}`);
      } catch (e) {
        return require('@/assets/img/what-we-do/notFound.png');
      }
    },
    verPerfil(url){

      window.open(url, '_blank');

    }
  },
};
</script>

<style scoped>
.google-font {
  font-family: 'Google Sans', sans-serif;
}
</style>
